import { Controller } from 'react-hook-form';

import { ReactCreatableSelect } from 'dashboard/components/ReactSelect';
import Form from 'dashboard/layouts/FormLayout/Form';
import { List } from 'dashboard/models/list';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { useFormSecurely } from 'lib/security/reactHookForm';

export interface FormSelectListData {
  selectedList: string;
}

interface FormSelectListProps {
  lists: List[];
  onSubmit: (data: FormSelectListData) => void;
  handleClose: () => void;
}

const FormSelectList = ({ lists, handleClose, onSubmit }: FormSelectListProps) => {
  const { handleSubmit, control } = useFormSecurely();

  const listOptions = lists.map((list) => {
    return {
      label: list.attributes.name,
      value: list.id,
    };
  });

  return (
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name='selectedList'
        render={({ field: { onChange, value } }) => (
          <ReactCreatableSelect
            id='select-list'
            placeholder='Select List'
            value={value}
            onChange={onChange}
            options={listOptions}
            portal={true}
          />
        )}
      />
      <Spacer height={2} />

      <HStack equal={true}>
        <Button variant='basic' id='add-to-list__cancel' onClick={handleClose}>
          Cancel
        </Button>
        <Button type='submit'>Add</Button>
      </HStack>
    </Form>
  );
};
export default FormSelectList;
